export default __webpack_public_path__ + "static/media/hht1_ep17_minisitcom_02.15c06e8a.png";